import {
  formatWithZonedDate,
  getCurrentDate,
  ServicePackageEnum,
  zonedDate,
} from "@repo/lib";
import { useRouteContext } from "@tanstack/react-router";
import { AssistProBanner } from "@/routes/settings/assist/-components/assist-pro-banner.tsx";
import { isProUserWithDeactivationDate } from "@/lib/assist-guard";

export const AssistProMenuBanner = (): JSX.Element => {
  const { user } = useRouteContext({ strict: false });

  const subscribedPackage =
    user.pacotesServicos.find(
      (servicePkg) => servicePkg.codPacoteServicos === ServicePackageEnum.Pro.valueOf(),
    ) ??
    user.pacotesServicos.find(
      (servicePkg) =>
        servicePkg.codPacoteServicos === ServicePackageEnum.Essential.valueOf(),
    );

  const isPro = subscribedPackage?.codPacoteServicos === ServicePackageEnum.Pro.valueOf();
  const trialEndDate = subscribedPackage?.dataFimTrial;
  const isTodayBeforeTrialEndDate =
    trialEndDate && zonedDate(trialEndDate) >= getCurrentDate();

  if (isProUserWithDeactivationDate(user)) {
    const formattedDate = trialEndDate
      ? formatWithZonedDate(trialEndDate, "d 'de' MMMM")
      : "";

    return (
      <AssistProBanner
        title={`Até ${formattedDate} é por nossa conta!`}
        description="Comece a usar o Assist Pro com acesso completo. Nossa equipe cuida da sua agenda enquanto você foca nos seus pacientes."
        to="/settings/assist/assist-pro-acceptance"
      />
    );
  }

  if (!isPro) {
    return (
      <AssistProBanner
        title="Dê o próximo passo com o Livance Assist Pro"
        description="Ative o plano e ofereça um atendimento ainda mais profissional"
        to="/settings/assist/subscribe-assist-pro"
        hasIcon
      />
    );
  }

  const formattedEndDate = trialEndDate
    ? formatWithZonedDate(trialEndDate, "dd/MM/yyyy")
    : "";

  const trialDescription =
    trialEndDate && isTodayBeforeTrialEndDate
      ? `Seu período de teste acaba em ${formattedEndDate}.`
      : undefined;

  return (
    <AssistProBanner
      title="Confira aqui os detalhes do seu plano e seu telefone exclusivo"
      description={trialDescription}
      to="/settings/assist/subscribed-assist"
    />
  );
};
